import { Component, ChangeDetectionStrategy } from '@angular/core';

import { BaseActionButton } from '../shared/base-button';
import { MatRipple } from '@angular/material/core';

@Component({
  selector: 'hypecast-master-admin-buttons-cancel',
  templateUrl: './buttons-cancel.component.html',
  styleUrls: ['./buttons-cancel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatRipple],
})
export class ButtonsCancelComponent extends BaseActionButton {}
